import {
  CourseEnrollmentStates,
  CourseValidationType,
} from '../Curriculum/types/CourseValidationType';

export function getColor(
  state?: CourseEnrollmentStates | CourseValidationType,
) {
  const ValidationTypeColors: Record<
    CourseEnrollmentStates | CourseValidationType,
    string
  > = {
    // CourseEnrollmentStates
    [CourseEnrollmentStates.Approved]: '#adf7a8',
    [CourseEnrollmentStates.Pending]: '#abcce9',
    [CourseEnrollmentStates.Reject]: '#ffa19d',
    [CourseEnrollmentStates.Enrolled]: '#fff784',
    [CourseEnrollmentStates.Validated]: '#BFACE2',
    // CourseValidationType
    [CourseValidationType.Internal]: '#F8C3FF',
    [CourseValidationType.RAP]: '#AFF4F1',
    [CourseValidationType.External]: '#FFCB8E',
  };

  if (!state) {
    return undefined;
  }
  return ValidationTypeColors[state] ?? undefined;
}
